import { API_TEMPLATE } from '../libs/constant'
import { post, get, callDelete, put } from '../libs/query'

const configApi = {
  getRegion () {
    const path = API_TEMPLATE.CONFIG_GET_REGION
    return get(path)
  },
  getRegionDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_REGION_DETAIL}?id=${id}`
    return get(path)
  },
  createRegion (region) {
    const path = API_TEMPLATE.CONFIG_ADD_REGION
    return post(path, region)
  },
  editRegion (region) {
    const path = `${API_TEMPLATE.CONFIG_UPDATE_REGION}`
    return post(path, region)
  },

  mappingRegion ({ values, provinceId }) {
    const path = `${API_TEMPLATE.CONFIG_MAPPING_REGION}?provinceId=${provinceId}`
    return post(path, values)
  },
  mappingProvince ({ regionId, values }) {
    const path = `${API_TEMPLATE.CONFIG_MAPPING_PROVINCE}?regionId=${regionId}`
    return post(path, values)
  },

  getMappingRegion (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_MAPPING_REGION}?regionId=${id}`
    return post(path)
  },
  getMappingProvince (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_MAPPING_PROVINCE}?provinceId=${id}`
    return post(path)
  },
  deleteMappingRegionProvince ({ regionId, provinceId }) {
    const path = `${API_TEMPLATE.CONFIG_DELETE_MAPPING_REGION_PROVINCE}?provinceId=${provinceId}&regionId=${regionId}`
    return callDelete(path)
  },

  getProvince () {
    const path = API_TEMPLATE.CONFIG_GET_PROVINCE
    return get(path)
  },
  getProvinceDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_PROVINCE_DETAIL}?id=${id}`
    return get(path)
  },
  createProvince (province) {
    const path = API_TEMPLATE.CONFIG_ADD_PROVINCE
    return post(path, province)
  },
  editProvince (province) {
    const path = `${API_TEMPLATE.CONFIG_UPDATE_PROVINCE}`
    return post(path, province)
  },

  getSchool () {
    const path = API_TEMPLATE.CONFIG_GET_SCHOOL
    return get(path)
  },
  getSchoolDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_SCHOOL_DETAIL}?id=${id}`
    return get(path)
  },
  createSchool (school) {
    const path = API_TEMPLATE.CONFIG_ADD_SCHOOL
    return post(path, school)
  },
  editSchool (school) {
    const path = `${API_TEMPLATE.CONFIG_UPDATE_SCHOOL}`
    return post(path, school)
  },

  getDevice () {
    const path = API_TEMPLATE.CONFIG_GET_DEVICE
    return get(path)
  },
  createDevice (device) {
    const path = API_TEMPLATE.CONFIG_ADD_DEVICE
    return post(path, device)
  },
  getDeviceDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_DEVICE_DETAIL}?id=${id}`
    return get(path)
  },
  editDevice (device) {
    const path = API_TEMPLATE.CONFIG_UPDATE_DEVICE
    return post(path, device)
  },

  getLevel () {
    const path = API_TEMPLATE.CONFIG_GET_LEVEL
    return get(path)
  },
  getLevelDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_LEVEL_DETAIL}?id=${id}`
    return get(path)
  },
  createLevel (level) {
    const path = API_TEMPLATE.CONFIG_ADD_LEVEL
    return post(path, level)
  },
  editLevel (level) {
    const path = API_TEMPLATE.CONFIG_UPDATE_LEVEL
    return post(path, level)
  },

  getGrade () {
    const path = API_TEMPLATE.CONFIG_GET_GRADE
    return get(path)
  },
  createGrade (grade) {
    const path = API_TEMPLATE.CONFIG_ADD_GRADE
    return post(path, grade)
  },
  getGradeDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_GRADE_DETAIL}?id=${id}`
    return get(path)
  },
  editGrade (grade) {
    const path = API_TEMPLATE.CONFIG_UPDATE_GRADE
    return post(path, grade)
  },

  getSubject () {
    const path = API_TEMPLATE.CONFIG_GET_SUBJECT
    return get(path)
  },
  createSubject (subject) {
    const path = API_TEMPLATE.CONFIG_ADD_SUBJECT
    return post(path, subject)
  },
  getSubjectDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_SUBJECT_DETAIL}?id=${id}`
    return get(path)
  },
  editSubject (subject) {
    const path = API_TEMPLATE.CONFIG_UPDATE_SUBJECT
    return post(path, subject)
  },

  getStudyProgram () {
    const path = API_TEMPLATE.CONFIG_GET_STUDY_PROGRAM
    return get(path)
  },
  createStudyProgram (StudyProgram) {
    const path = API_TEMPLATE.CONFIG_ADD_STUDY_PROGRAM
    return post(path, StudyProgram)
  },
  getStudyProgramDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_STUDY_PROGRAM_DETAIL}/${id}`
    return get(path)
  },
  editStudyProgram (StudyProgram) {
    const path = API_TEMPLATE.CONFIG_UPDATE_STUDY_PROGRAM
    return put(path, StudyProgram)
  },

  getCrmPackage () {
    const path = API_TEMPLATE.CONFIG_GET_CRM_PACKAGE
    return get(path)
  },
  getCrmPackageByStudyProgramId (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_CRM_PACKAGE_BY_STUDY_PROGRAM_ID}?id=${id}`
    return get(path)
  },
  getCrmPackageById (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_CRM_PACKAGE_BY_ID}?id=${id}`
    return get(path)
  },
  createCrmPackage (payload) {
    const path = API_TEMPLATE.CONFIG_ADD_CRM_PACKAGE
    return post(path, payload)
  },
  deleteCrmPackage (payload) {
    const path = API_TEMPLATE.CONFIG_DELETE_CRM_PACKAGE
    return post(path, payload)
  },

  createTeacherClassify (payload) {
    const path = API_TEMPLATE.CONFIG_ADD_TEACHER_CLASSIFY
    return post(path, payload)
  },
  mappingTeacherClassify ({ values, classifyId }) {
    const path = `${API_TEMPLATE.CONFIG_MAP_TEACHER_CLASSIFY}?classifyId=${classifyId}`
    return post(path, values)
  },
  getAllTeacherClassify (payload) {
    const path = API_TEMPLATE.CONFIG_GET_TEACHER_CLASSIFY
    return post(path, payload)
  },
  getDetailTeacherClassify (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_DETAIL_TEACHER_CLASSIFY}?id=${id}`
    return get(path)
  },
  deleteTeacherClassifyTeacher ({ ids, classifyId }) {
    const path = `${API_TEMPLATE.CONFIG_DELETE_TEACHER_CLASSIFY_TEACHER}?classifyId=${classifyId}`
    return post(path, ids)
  },
  editTutorFile (payload) {
    const path = API_TEMPLATE.CONFIG_UPDATE_TUTOR_FILE
    return post(path, payload)
  },

  createSalaryGroup (payload) {
    const path = API_TEMPLATE.CONFIG_CREATE_SALARY_GROUP
    return post(path, payload)
  },

  editSalaryGroup (payload) {
    const path = API_TEMPLATE.CONFIG_UPDATE_SALARY_GROUP
    return post(path, payload)
  },

  getListSalaryGroup () {
    const path = API_TEMPLATE.CONFIG_GET_LIST_SALARY_GROUP
    return get(path)
  },

  getTeacherInSalaryGroup (id) {
    const path = API_TEMPLATE.CONFIG_GET_TEACHER_IN_SALARY_GROUP
    return get(`${path}?page=0&size=10000&teacherLevelId=${id}`)
  },

  addTeacherToSalaryGroup (payload) {
    const path = API_TEMPLATE.CONFIG_ADD_TEACHER_TO_SALARY_GROUP
    return post(path, payload)
  },

  removeTeacherInSalaryGroup (payload) {
    const path = API_TEMPLATE.CONFIG_REMOVE_TEACHER_IN_SALARY_GROUP
    return post(path, payload)
  },

  createBreachGroup (payload) {
    const path = API_TEMPLATE.CONFIG_CREATE_BREACH_GROUP
    return post(path, payload)
  },

  editBreachGroup (payload) {
    const path = API_TEMPLATE.CONFIG_UPDATE_BREACH_GROUP
    return post(path, payload)
  },

  getListBreachGroup () {
    const path = API_TEMPLATE.CONFIG_GET_LIST_BREACH_GROUP
    return get(path)
  },

  getTeacherInBreachGroup (id) {
    const path = API_TEMPLATE.CONFIG_GET_TEACHER_IN_BREACH_GROUP
    return get(`${path}?page=0&size=10000&violationLevelId=${id}`)
  },

  addTeacherToBreachGroup (payload) {
    const path = API_TEMPLATE.CONFIG_ADD_TEACHER_TO_BREACH_GROUP
    return post(path, payload)
  },

  removeTeacherInBreachGroup (payload) {
    const path = API_TEMPLATE.CONFIG_REMOVE_TEACHER_IN_BREACH_GROUP
    return post(path, payload)
  },

  filterMakeUpSessionNumber (payload) {
    const path = API_TEMPLATE.CONFIG_MAKE_UP_SESSION_NUMBER_FILTER
    return post(path, {
      ...payload,
      sortOrders: [
        {
          field: 'updatedAt',
          isASC: false
        }
      ]
    })
  },

  createMakeUpSessionNumber (payload) {
    const path = API_TEMPLATE.CONFIG_MAKE_UP_SESSION_NUMBER_CREATE
    return post(path, { ...payload })
  },

  updateMakeUpSessionNumber (payload) {
    const path = API_TEMPLATE.CONFIG_MAKE_UP_SESSION_NUMBER_UPDATE
    return post(path, { ...payload })
  },

  createTeacherManager (payload) {
    const path = API_TEMPLATE.CONFIG_CREATE_TEACHER_MANAGER
    return post(path, payload)
  },

  editTeacherManager (payload) {
    const path = API_TEMPLATE.CONFIG_UPDATE_TEACHER_MANAGER
    return post(path, payload)
  },

  getListTeacherManager () {
    const path = API_TEMPLATE.CONFIG_GET_LIST_TEACHER_MANAGER
    return post(path)
  },

  getTeacherInTeacherManager (id) {
    const path = API_TEMPLATE.CONFIG_GET_TEACHER_IN_TEACHER_MANAGER
    return get(`${path}?id=${id}`)
  },

  addTeacherToTeacherManager ({ tmGroupId, ids }) {
    const path = `${API_TEMPLATE.CONFIG_ADD_TEACHER_TO_TEACHER_MANAGER}?tmGroupId=${tmGroupId}`
    return post(path, ids)
  },

  removeTeacherInTeacherManager ({ tmGroupId, payload }) {
    const path = `${API_TEMPLATE.CONFIG_REMOVE_TEACHER_IN_TEACHER_MANAGER}?tmGroupId=${tmGroupId}`
    return post(path, payload)
  },

  getListLearningModel () {
    const path = API_TEMPLATE.CONFIG_GET_LEARNING_MODEL
    return get(path)
  },
  getLearningModelDetail (id) {
    const path = `${API_TEMPLATE.CONFIG_GET_LEARNING_MODEL_DETAIL}/${id}`
    return get(path)
  },
  createLearningModel (payload) {
    const path = API_TEMPLATE.CONFIG_ADD_LEARNING_MODEL
    return post(path, payload)
  },
  updateLearningModel ({ id, ...rest }) {
    const path = `${API_TEMPLATE.CONFIG_UPDATE_LEARNING_MODEL}/${id}`
    return put(path, { ...rest })
  },

  //cấu hình chỉ số theo dõi gia sư
  getConfigTrackingMetric () {
    return get(API_TEMPLATE.TRACKING_METRIC_GET)
  },
  getConfigTrackingMetricDetail (id) {
    return get(API_TEMPLATE.TRACKING_METRIC_GET_DETAIL)
  },
  addConfigTrackingMetric (payload) {
    const path = API_TEMPLATE.TRACKING_METRIC_ADD
    return put(path, payload)
  },
  getCanvasCourse () {
    return get(API_TEMPLATE.TRACKING_METRIC_GET_CANVAS_COURSE)
  },
  getModuleCourse (id) {
    return get(`${API_TEMPLATE.TRACKING_METRIC_GET_MODULE}/${id}/modules`)
  },
  getQuizCourse ({ moduleId, courseId }) {
    return get(`${API_TEMPLATE.TRACKING_METRIC_GET_QUIZ}/${courseId}/modules/${moduleId}/items`)
  },

  getConfigComponentScoreWeights () {
    return get(API_TEMPLATE.COMPONENT_SCORE_WEIGHTS_GET)
  },
  getConfigComponentScoreWeightsHistory (id) {
    return get(`${API_TEMPLATE.COMPONENT_SCORE_WEIGHTS_GET_DETAIL}?qcsId=${id}`)
  },
  addConfigComponentScoreWeights (payload) {
    const path = API_TEMPLATE.COMPONENT_SCORE_WEIGHTS_ADD
    return post(path, payload)
  },
  getQcsWeightConfig ({ type, date }) {
    const path = `${API_TEMPLATE.QCS_WEIGHT_CONFIG_GET_WEIGHT}?type=${type}&date=${date}`
    return get(path)
  },

  getCupEvaluator(id) {
    const path = `${API_TEMPLATE.CONFIG_CUP_EVALUATOR}/${id}`
    return get(path)
  },

  getListConfigPotential () {
    return get(API_TEMPLATE.CONFIG_GET_LIST_POTENTIAL_POINTS)
  },
  geConfigPotentialDetail (id) {
    return get(`${API_TEMPLATE.CONFIG_GET_DETAIL_POTENTIAL_POINTS}?id=${id}`)
  },
  geConfigHistoryPotentialDetail (id) {
    return get(`${API_TEMPLATE.CONFIG_GET_HISTORY_POTENTIAL_POINTS}?id=${id}`)
  },
  updateActivePotentialDetail (payload) {
    const path = API_TEMPLATE.CONFIG_ACTIVE_STATUS_POTENTIAL_POINTS
    return post(path, payload)
  },
  updateDeActivePotentialDetail (payload) {
    const path = API_TEMPLATE.CONFIG_DEACTIVE_STATUS_POTENTIAL_POINTS
    return post(path, payload)
  },
  updatePotentialDetail (payload) {
    const path = API_TEMPLATE.CONFIG_UPDATE_POTENTIAL_POINTS
    return post(path, payload)
  },

  //training-specialist
  getAllTrainingSpecialist () {
    return get(`${API_TEMPLATE.CONFIG_GET_LIST_TRAINING_SPECIALIST}`)
  },
  getDetailTrainingSpecialist (id) {
    return get(`${API_TEMPLATE.CONFIG_GET_LIST_TEACHER_TRAINING_SPECIALIST.replace('{id}', id)}`)
  },
  addTrainingSpecialist (id) {
    return post(`${API_TEMPLATE.CONFIG_ADD_TRAINING_SPECIALIST.replace('{id}', id)}`)
  },
  assignTeacherTrainingSpecialist ({ id, ids }) {
    return post(`${API_TEMPLATE.CONFIG_ASSIGN_TEACHER_TRAINING_SPECIALIST.replace('{id}', id)}`, ids)
  },
  removeTeacherTrainingSpecialist ({ id, ids }) {
    return post(`${API_TEMPLATE.CONFIG_REMOVE_TEACHER_TRAINING_SPECIALIST.replace('{id}', id)}`, ids)
  },

  // class-acceptance-rate
  getClassAcceptanceRate () {
    return get(`${API_TEMPLATE.CONFIG_GET_CLASS_ACCEPTANCE_RATE}`)
  },
  updateClassAcceptanceRate (payload) {
    return put(`${API_TEMPLATE.CONFIG_UPDATE_CLASS_ACCEPTANCE_RATE}`, payload)
  },

  // config-reset-exam
  /**
   * Xoá dữ liệu bài thi lý thuyết Tutor của tháng đánh giá.
   *
   * @param {{ month: number, profileIds: number[] }} payload - month dạng YYYYMM (vd 202610), tối đa 20 profileId.
   * @returns {Promise<any>} data: { results: [{ profileId, status: 'RESET' | 'NOT_FOUND' | 'ERROR' }] }
   */
  resetMonthlyExamTheory (payload) {
    return post(API_TEMPLATE.CONFIG_RESET_MONTHLY_EXAM_THEORY, payload)
  },
}

export default configApi
